import { Typography } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    sectionName: {
      fontSize: 12,
      fontWeight: 600,
    },
    text: {
      fontSize: 12,
    },
  }),
);

interface Props {
  title: string;
  desc?: string;
}

export const CampaignName = ({ title, desc }: Props) => {
  const { message } = useMessage();
  const classes = useStyles();

  return (
    <div>
      <Typography className={classes.sectionName}>
        {message({ id: "title" })}:
      </Typography>
      <Typography className={classes.text}>{title}</Typography>
      {desc && (
        <>
          <Typography mt={8} className={classes.sectionName}>
            {message({ id: "description" })}:
          </Typography>
          <Typography className={classes.text}>{desc}</Typography>
        </>
      )}
    </div>
  );
};
